import React, { Component } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import uuid from "uuid";

class PdfDownload extends Component {
  constructor(props) {
    super(props);
    this.printing = false;
    this.identifier = uuid();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.print && !this.printing) {
      this.printing = true;
      this.printDocument();
    }
  }

  async printDocument() {
    this.props.setLoading(true);
    const input = document.getElementById(this.identifier);
    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");

    const pageHeight = 297;
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let position = 0;
    let heightLeft = imgHeight;
    const pdf = new jsPDF("p", "mm");

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("etiqueta.pdf");
    this.props.setLoading(false);
    this.printing = false;
    this.props.onPrintFinished && this.props.onPrintFinished();
  }

  render() {
    return (
      <div
        style={{ width: 0, height: 0, overflow: "hidden", position: "fixed" }}
      >
        <div id={this.identifier} style={{ width: "210mm" }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default PdfDownload;



// WEBPACK FOOTER //
// ./src/components/support/pdf-download/index.jsx